import { render, staticRenderFns } from "./GroupPackages.vue?vue&type=template&id=b1df90b0&scoped=true&"
import script from "./GroupPackages.vue?vue&type=script&lang=js&"
export * from "./GroupPackages.vue?vue&type=script&lang=js&"
import style0 from "./GroupPackages.vue?vue&type=style&index=0&id=b1df90b0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1df90b0",
  null
  
)

export default component.exports